import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=972869fc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972869fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('972869fc')) {
      api.createRecord('972869fc', component.options)
    } else {
      api.reload('972869fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=972869fc&scoped=true&", function () {
      api.rerender('972869fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rXymlfBWwVlO/JS/comp/SearchFilterTokens.vue"
export default component.exports